import { module } from './store'
import { StorefrontModule } from '@vue-storefront/core/lib/modules'

export const KEY = 'venues'

export const Venues: StorefrontModule = function ({ store }) {
  store.registerModule(KEY, module)
}
